import React from 'react';
import styles from './Hero.module.css';
// import logo from '../assets/logo.png';

const Hero = () => {
  return (
    <section className={styles.hero}>
      {/* <img src={logo} alt="BETA Logo" className={styles.logo} /> */}
      <h1>Breakthrough Engineering and Technology Applications</h1>
      <p>Innovating the future, one breakthrough at a time.</p>
    </section>
  );
};

export default Hero;
